<template>
  <div class="activity-timeline-component" v-bind:class="{loaded: !loading}">
    <lazy-component v-on:intersected="onInit" v-bind:is-intersected="forceIntersect">
      <div v-if="loading">
        <Skeleton class="skeleton" v-bind:loading="true"
                  style="width: 100%;height: 20px;display: inline-block; margin: 10px 0 20px;"></Skeleton>
        <Skeleton class="skeleton" v-bind:loading="true"
                  style="width: 100%;height: 20px;display: inline-block; margin: 10px 0 20px;"></Skeleton>
        <Skeleton class="skeleton" v-bind:loading="true"
                  style="width: 100%;height: 20px;display: inline-block; margin: 10px 0 20px;"></Skeleton>
        <Skeleton class="skeleton" v-bind:loading="true"
                  style="width: 100%;height: 20px;display: inline-block; margin: 10px 0 20px;"></Skeleton>
      </div>
      <a-timeline v-if="!loading">
        <activity-timeline-item :activity="activity" :key="activity.id"
                                v-for="activity in activities"></activity-timeline-item>
      </a-timeline>
    </lazy-component>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import activityApi from '~/api/activity'
import ActivityTimeLineItem from './ActivityTimelineItemComponent'
import { Skeleton } from 'vue-loading-skeleton'

export default {
  name: 'ActivityTimelineComponent',
  components: {
    'activity-timeline-item': ActivityTimeLineItem,
    Skeleton,
  },
  props: {
    customer_id: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: true,
      activities: []
    }
  },
  created () {
    // const STORE_KEY = '$_attachable';
    // // eslint-disable-next-line no-underscore-dangle
    // if (!(STORE_KEY in this.$store._modules.root._children)) {
    //   this.$store.registerModule(STORE_KEY, store);
    // }
  },
  computed: {
    ...mapGetters([
      'forceIntersect'
    ]),
    ...mapGetters({
      breadcrumbs: '$_attachable/breadcrumbs',
    }),
  },
  methods: {
    onInit () {
      this.loadActivity()
    },
    loadActivity () {
      activityApi.search(this.customer_id).then((data) => {
        this.activities = data.data
      }).catch(() => {
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: 'Het is niet gelukt om activiteit te laden',
        })
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted () {
  }
}
</script>

<style scoped>
div.spinner {
  align-content: center;
}
</style>
